import { get } from 'lodash';

import app from '../../../scripts/app';
import validation from '../../../scripts/services/validation';

import template from './new-building-form.jade';

app.directive('cianAfNewBuildingForm', [function() {
  return {
    template,
    scope: {},
    bindToController: {
    },
    controller: ['$scope', 'userService', 'apiService', 'addFormService', 'addFormLayoutService', 'addressService', 'deviceService', function($scope, userService, apiService, addFormService, addFormLayoutService, addressService, deviceService) {
      this.isMobile = deviceService.isMobile;
      this.data = {};
      this.requestSended = addFormLayoutService.isReqestSended(addressService.getUserInput());
      this.requestInProgress = false;

      // получаем email пользователя
      userService.getUser().then(user => {
        // если в процессе запроса пользователь уже что-то ввел в поле, не подставляем полученное значение
        if (!this.data.contact) {
          this.data.contact = user.email;
        }
      });

      // ждем инициализацию формы
      const waitForFormInit = $scope.$watch(() => this.form, () => {
        this.validationContact = validation(this.form, 'contact', {
          required: 'Введите контактную информацию',
        });

        this.validationMessage = validation(this.form, 'message', {
          required: 'Укажите какое здание необходимо добавить в каталог',
        });

        waitForFormInit();
      });

      this.submit = () => {
        if (!this.form.$valid) {
          return;
        }

        const request = {
          offerType: 'bc',
          message: this.data.message,
          contacts: this.data.contact,
          title: get(addFormService.ad, 'building.name', ''),
          address: addressService.getUserInput()
        };

        this.requestInProgress = true;
        apiService.addObjectRequest(request).then(res => {
          this.requestSended = true;
          addFormLayoutService.appendToSendedRequests(request.address);
        }).catch(err => {
          this.requestSended = false;
        }).finally(() => {
          this.requestInProgress = false;
        });
      };
    }],
    controllerAs: 'newBuildingFormCtrl',
  };
}])
.directive('cianAfTextareaPlaceholder', () => ({
  restrict: 'A',
  link: function(scope, element, attrs) {
    const placeholder = attrs.placeholder;
    if (placeholder) {
      element.find('textarea').attr('placeholder', placeholder);
    }
  }
}));
